/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1671
 */

require(/* 86 */"./1650/86/index")({
  target: "Object",
  stat: true
}, {
  is: require(/* 1264 */"./1722/1264")
})
